import { FormatInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';
import { observer } from 'mobx-react-lite';
import { StepCard } from '../StepCard';
import { ConfigurationStepId } from 'src/helpers/configurationSteps.helper';
import { StepCardProps } from '../StepCard.types';

export const FormatCards = observer((props: StepCardProps<FormatInfo>) => {
  const Component = StepCard<FormatInfo>;
  return (
    <Component
      {...props}
      getIsSuggestedCard={card => card.isSuggested}
      configurationStepId={ConfigurationStepId.FORMAT}
    />
  );
});
